import {
  BASE_URL,
  PROXY_SERVER,
  SERVER_BASE_URL,
  useProxy
} from "../../constants/common";

// un-comment the following lines to use the hosted server directly, replace the URL with the correct one matching the environment
// only use this for testing purposes locally, for production use the proxy server
/* export const baseUrlServer = "https://api-qa.roosterinc.com"; 
export const baseUrlFunctions =
  "https://us-central1-rooster-qa.cloudfunctions.net"; */

export const baseUrlServer = `${useProxy ? PROXY_SERVER : ""}${SERVER_BASE_URL}`;
export const baseUrlFunctions = `${useProxy ? PROXY_SERVER : ""}${BASE_URL}`;
